export const SETTINGS_SECTIONS = {
  timeAndAttendance: "time-and-attendance",
  workerCredentials: "worker-credentials",
  scheduling: "scheduling",
  compliance: "compliance",
  rateAndBilling: "rate-and-billing",
  jobManagement: "job-management",
  calendarDisplay: "calendar-display",
  translation: "translation",
  appInfo: "app-info",
} as const;

export type SettingsSection = (typeof SETTINGS_SECTIONS)[keyof typeof SETTINGS_SECTIONS];

export interface SettingsSectionConfig {
  id: SettingsSection;
  title: string;
  description: string;
}

export interface SettingsPermissions {
  /** Whether the current user has CBH admin privileges */
  isAdmin: boolean;
  /** Whether the current user has the facility ADM role (or is admin) */
  isFacilityAdmin: boolean;
  /** Whether the current user has the facility SFT role (or is admin) */
  hasShiftManagement: boolean;
  /** Whether the current user has the facility INV role (or is admin) */
  hasInvoices: boolean;
}
